var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operationText,
          backUrl: _vm.backUrl,
          "close-now-tag": "",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            _vm._l(_vm.headTabs, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.tit, name: item.name },
              })
            }),
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formData",
              staticClass: "form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formData,
                "label-width": "130px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.currentTab >= "1"
                ? _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "1",
                          expression: "currentTab === '1'",
                        },
                      ],
                      attrs: { gutter: 24 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "所属应用：",
                                prop: "applicationId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    disabled: _vm.isDisabled || _vm.isEdit,
                                  },
                                  on: { change: _vm.changeApp },
                                  model: {
                                    value: _vm.formData.applicationId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "applicationId",
                                        $$v
                                      )
                                    },
                                    expression: "formData.applicationId",
                                  },
                                },
                                _vm._l(_vm.appList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "活动封面：",
                                prop: "activityImage",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "upLoadPicBox acea-row",
                                  on: {
                                    click: function ($event) {
                                      return _vm.modalPicTap()
                                    },
                                  },
                                },
                                [
                                  _vm.formData.activityImage
                                    ? _c("div", { staticClass: "pictrue" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.formData.activityImage,
                                          },
                                        }),
                                      ])
                                    : _c("div", { staticClass: "upLoad" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-camera cameraIconfont",
                                        }),
                                      ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "活动名称：", prop: "title" } },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  maxlength: 100,
                                  "show-word-limit": "",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formData.title,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "title",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "连签天数：",
                                prop: "continuousDays",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    placeholder: "请选择连签天数",
                                  },
                                  on: { change: _vm.changeContinuousDays },
                                  model: {
                                    value: _vm.formData.continuousDays,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "continuousDays",
                                        $$v
                                      )
                                    },
                                    expression: "formData.continuousDays",
                                  },
                                },
                                _vm._l(
                                  _vm.continuousDaysTypeOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "连签奖励：",
                                prop: "rewardValue",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 0.01,
                                  step: 0.01,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                },
                                model: {
                                  value: _vm.formData.rewardValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "rewardValue", $$v)
                                  },
                                  expression: "formData.rewardValue",
                                },
                              }),
                              _vm._v("元 "),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "可续签次数：",
                                prop: "renewTimes",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 0,
                                  step: 1,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                },
                                model: {
                                  value: _vm.formData.renewTimes,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "renewTimes", $$v)
                                  },
                                  expression: "formData.renewTimes",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "续签方式：", prop: "renewType" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    placeholder: "请选择续签方式",
                                  },
                                  model: {
                                    value: _vm.formData.renewType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "renewType", $$v)
                                    },
                                    expression: "formData.renewType",
                                  },
                                },
                                _vm._l(_vm.renewTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.formData.renewType === 1
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "激励视频数量：",
                                    prop: "rewardVideoCount",
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 1,
                                      step: 1,
                                      "controls-position": "right",
                                      "step-strictly": "",
                                    },
                                    model: {
                                      value: _vm.formData.rewardVideoCount,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "rewardVideoCount",
                                          $$v
                                        )
                                      },
                                      expression: "formData.rewardVideoCount",
                                    },
                                  }),
                                  _c("div", { staticClass: "from-tips" }, [
                                    _vm._v("注：观看X次激励视频完成1次续签"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            { attrs: { label: "活动说明：", prop: "rules" } },
                            [
                              _c(
                                "div",
                                { staticStyle: { width: "500px" } },
                                [
                                  !_vm.isDisabled
                                    ? _c("Tinymce", {
                                        model: {
                                          value: _vm.formData.rules,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.formData, "rules", $$v)
                                          },
                                          expression: "formData.rules",
                                        },
                                      })
                                    : _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(_vm.formData.rules),
                                        },
                                      }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态：", prop: "status" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formData.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "status", $$v)
                                  },
                                  expression: "formData.status",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "排序：", prop: "sort" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 0,
                                  step: 1,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                },
                                model: {
                                  value: _vm.formData.sort,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "sort", $$v)
                                  },
                                  expression: "formData.sort",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.currentTab >= "2"
                ? _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "2",
                          expression: "currentTab === '2'",
                        },
                      ],
                      attrs: { gutter: 24 },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "开启延时任务：",
                            prop: "isDelayTask",
                          },
                        },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "开启",
                              "inactive-text": "关闭",
                              disabled: _vm.isDisabled,
                            },
                            model: {
                              value: _vm.formData.isDelayTask,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "isDelayTask", $$v)
                              },
                              expression: "formData.isDelayTask",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.formData.isDelayTask
                        ? [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "延时任务标题：",
                                  prop: "delayTitle",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    maxlength: 100,
                                    "show-word-limit": "",
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.formData.delayTitle,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "delayTitle",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formData.delayTitle",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "延时任务开始天数：",
                                  prop: "delayStartDay",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { disabled: _vm.isDisabled },
                                    on: { change: _vm.changeDelayStartDay },
                                    model: {
                                      value: _vm.formData.delayStartDay,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "delayStartDay",
                                          $$v
                                        )
                                      },
                                      expression: "formData.delayStartDay",
                                    },
                                  },
                                  _vm._l(
                                    _vm.formData.continuousDays,
                                    function (i) {
                                      return _c("el-option", {
                                        key: i,
                                        attrs: {
                                          label: "第" + i + "天",
                                          value: i,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                _c("div", { staticClass: "from-tips" }, [
                                  _vm._v("注：第X天开始延时任务"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "延时任务结束天数：",
                                  prop: "delayEndDay",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { disabled: _vm.isDisabled },
                                    model: {
                                      value: _vm.formData.delayEndDay,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "delayEndDay",
                                          $$v
                                        )
                                      },
                                      expression: "formData.delayEndDay",
                                    },
                                  },
                                  _vm._l(
                                    _vm.formData.continuousDays,
                                    function (i) {
                                      return _c("el-option", {
                                        key: i,
                                        attrs: {
                                          label: "第" + i + "天",
                                          value: i,
                                          disabled:
                                            i < _vm.formData.delayStartDay,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                _c("div", { staticClass: "from-tips" }, [
                                  _vm._v("注：第X天结束延时任务"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "延时任务页面路径：",
                                  prop: "delayPagePath",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticClass: "from-ipt-width",
                                  attrs: { disabled: _vm.isDisabled },
                                  model: {
                                    value: _vm.formData.delayPagePath,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "delayPagePath",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "formData.delayPagePath",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "延时任务完成次数：",
                                  prop: "delayRequiredCount",
                                },
                              },
                              [
                                _c("el-input-number", {
                                  attrs: {
                                    min: 1,
                                    max: 9999,
                                    step: 1,
                                    "controls-position": "right",
                                    "step-strictly": "",
                                  },
                                  model: {
                                    value: _vm.formData.delayRequiredCount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "delayRequiredCount",
                                        $$v
                                      )
                                    },
                                    expression: "formData.delayRequiredCount",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.formData.taskConfigs,
                            "span-method": _vm.objectSpanMethod,
                            border: "",
                            height: "500",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "第几天",
                              width: "130",
                              prop: "effectDay",
                              fixed: "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          "第" + scope.row.effectDay + "天"
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2984508179
                            ),
                          }),
                          _c(
                            "el-table-column",
                            {
                              attrs: { label: "任务类型", width: "160" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              disabled:
                                                scope.row.taskSort === 1,
                                            },
                                            model: {
                                              value: scope.row.taskType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "taskType",
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row.taskType",
                                            },
                                          },
                                          _vm._l(
                                            _vm.taskTypeOptions,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.value,
                                                attrs: {
                                                  label: item.label,
                                                  value: item.value,
                                                  disabled: item.value === 1,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                641903097
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("div", { staticClass: "required" }, [
                                  _vm._v("任务类型"),
                                ]),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: { label: "任务标题", "min-width": "180" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input", {
                                          attrs: {
                                            maxlength: 100,
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value: scope.row.taskTitle,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "taskTitle",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "scope.row.taskTitle",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3420697385
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("div", { staticClass: "required" }, [
                                  _vm._v("任务标题"),
                                ]),
                              ]),
                            ],
                            2
                          ),
                          _c(
                            "el-table-column",
                            {
                              attrs: { label: "完成次数", width: "160" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input-number", {
                                          attrs: {
                                            disabled: scope.row.taskType === 1,
                                            min: 1,
                                            max: 9999,
                                            step: 1,
                                            "controls-position": "right",
                                            "step-strictly": "",
                                          },
                                          model: {
                                            value: scope.row.dailyLimit,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "dailyLimit",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.dailyLimit",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                40241971
                              ),
                            },
                            [
                              _c("template", { slot: "header" }, [
                                _c("div", { staticClass: "required" }, [
                                  _vm._v("完成次数"),
                                ]),
                              ]),
                            ],
                            2
                          ),
                          _c("el-table-column", {
                            attrs: { label: "配置项", "min-width": "580" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.taskType === 2
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "acea-row row-middle",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "acea-row row-middle",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "required" },
                                                    [_vm._v("小程序APPID：")]
                                                  ),
                                                  _c("el-input", {
                                                    staticClass: "table-input",
                                                    attrs: {
                                                      maxlength: 100,
                                                      "show-word-limit": "",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .miniProgramAppId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "miniProgramAppId",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.miniProgramAppId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "acea-row row-middle ml5",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "required" },
                                                    [_vm._v("页面路径：")]
                                                  ),
                                                  _c("el-input", {
                                                    staticClass: "table-input",
                                                    model: {
                                                      value:
                                                        scope.row
                                                          .miniProgramUrl,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "miniProgramUrl",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.miniProgramUrl",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              868917701
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "100",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.taskSort === 1
                                        ? _c(
                                            "a",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addTaskItem(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("添加任务")]
                                          )
                                        : scope.row.taskSort !== 1
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "red",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeTaskItem(
                                                    scope.$index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2454074334
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { staticClass: "mt10" },
                [
                  Number(_vm.currentTab) > 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "submission priamry_border",
                          on: { click: _vm.handleSubmitLast },
                        },
                        [_vm._v("上一步")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: Number(_vm.currentTab) < _vm.headTabs.length,
                          expression: "Number(currentTab) < headTabs.length",
                        },
                      ],
                      staticClass: "priamry_border",
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitNext("formData")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: [
                                "platform:marketing:sign-challenge:update",
                              ],
                              expression:
                                "['platform:marketing:sign-challenge:update']",
                            },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isDisabled,
                              expression: "!isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formData")
                            },
                          },
                        },
                        [_vm._v(" 保存")]
                      )
                    : _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: [
                                "platform:marketing:sign-challenge:create",
                              ],
                              expression:
                                "['platform:marketing:sign-challenge:create']",
                            },
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.currentTab === "2" ||
                                  _vm.$route.params.id) &&
                                !_vm.isDisabled,
                              expression:
                                "(currentTab === '2' || $route.params.id) && !isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formData")
                            },
                          },
                        },
                        [_vm._v(" 保存")]
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }